export const FETCHING_PARTS_SALES_LIST = '@@toyota/FETCHING_PARTS_SALES_LIST';
export const FETCHED_PARTS_SALES_LIST = '@@toyota/FETCHED_PARTS_SALES_LIST';
export const FETCHED_PARTS_SALES_LIST_FAILED = '@@toyota/FETCHED_PARTS_SALES_LIST_FAILED';
export const DOWNLOADING_PARTS_SALES_LIST = '@@toyota/DOWNLOADING_PARTS_SALES_LIST';
export const DOWNLOADED_PARTS_SALES_LIST = '@@toyota/DOWNLOADED_PARTS_SALES_LIST';
export const DOWNLOADED_PARTS_SALES_LIST_FAILED = '@@toyota/DOWNLOADED_PARTS_SALES_LIST_FAILED';
